import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface UseRowProps {
  handle: string;
  read: number;
  write: number;
}

function UseRow({handle, read, write}: UseRowProps): JSX.Element {
  return (
    <tr>
      <td>
        <a target="_blank" href={`/${handle}`} rel="noopener noreferrer">
          {handle}
        </a>
      </td>
      <td>{read}</td>
      <td>{write}</td>
      <td>{read + write}</td>
    </tr>
  );
}

export default makeDeprecatedJadeStyleTemplate<UseRowProps>(UseRow);
